<template>
    <div>
        <el-form :model="editItem" :rules="formRules" ref="editFormRef" label-width="150px">
            <el-row>
                <el-col :span="18">
                    <el-form-item label="产品名称：" prop="name">
                        <el-input v-model="editItem.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="产品代码：" prop="code">
                        <el-input v-model="editItem.code"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="产品分类：" prop="categoryId">
                        <CategoryCascade v-model="editItem.categoryId" @nodeChange="nodeCategoryCascader"></CategoryCascade>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="上门安装：" prop="onset">
                        <el-select v-model="editItem.onSite" placeholder="否" style="width: 100%;">
                            <el-option
                                    v-for="item in onsites"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="editItem.id!=undefined">
                <el-col :span="18">
                    <el-form-item label="产品图片：" prop="avatar">
                        <el-upload  v-permission="['PRODUCT-MODEL-AVATAR']"
                                class="avatar-uploader"
                                :class="{hide:hideUploadIcon}"
                                ref="upload"
                                :action="''"
                                :multiple="false"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :limit="1"
                                :on-change="onchange"
                                :show-file-list="false"
                                :auto-upload="false">
                            <img v-if="yulanimg===''" :src="productImg" class="avatar">
                            <img v-else-if="yulanimg!=''" :src="yulanimg" class="avatar">
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import CategoryCascade from '@/components/category/Cascader'
    import {productImg} from '@/api/product'
    export default {
        name: '',
        props: {
            item: {
                type: Object,
                default: function () {
                    return {
                        name: '',
                        code: '',
                        categoryId: 1,
                        onSite: false,
                        path: ''
                    }
                }
            }
        },
        data(){
            return {
                onsites: [
                    {value: false,label: '否'},
                    {value: true,label: '是'}
                ],
                hideUploadIcon: true,
                yulanimg: ''
            }
        },
        components: {
            CategoryCascade
        },
        methods:{
            async validateForm() {
                let p =await  new Promise((resolve, reject)=>{
                    this.$refs.editFormRef.validate(async (valid)=>{
                        valid ? resolve() : reject()
                    })
                })
                return p
            },
            nodeCategoryCascader(val){
                this.editItem.categoryId = val[val.length-1]
            },
            handlePreview(file) {
                console.log(file)
            },
            handleRemove(){

            },
            //当上传图片后，调用onchange方法，获取图片本地路径
            onchange(file,fileList){
                const isJPG = file.raw.type === 'image/jpeg'
                const isPNG = file.raw.type === 'image/png'
                const isLt2M = file.size / 1024 / 1024 < 2
                this.hideUploadIcon = fileList.length >= 1
                if (!isPNG && !isJPG) {
                    this.$message.error('上传图片只能是 JPG/PNG 格式!')
                    return false
                } else if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!')
                    return false
                } else if (isLt2M && (isPNG || isJPG)) {
                    var _this = this
                    var f = file.raw
                    var reader = new FileReader()
                    //转base64
                    reader.onload = function(e) {
                        _this.yulanimg = e.target.result //将图片路径赋值给src
                    }
                    reader.readAsDataURL(f)
                    // this.updataImgForm.imgname = file.name //图片的名字
                    // this.updataImgForm.file = file.raw
                    let param = new FormData()
                    param.append('file',file.raw)
                    productImg(param,this.item.id).then(response => {
                        console.log(response)
                        if (response.code != 200)
                            return this.$message.error(response.msg)
                        this.$message.success(response.msg)
                    })
                }
            }
        },
        computed: {
            ...mapGetters([
                'token'
            ]),
            formRules: function(){
                let arr= {}
                arr.name = [
                    { required: true, message: '请输入产品名称', trigger: 'blur' }
                ]
                arr.code = [
                    { required: true, message: '请输入产品代码', trigger: 'blur' }
                ]
                arr.ancestors = [
                    { required: true, message: '请选择产品分类', trigger: 'blur' }
                ]
                return arr
            },
            editItem: function (){
                return this.item
            },
            productImg(){
                if (this.editItem.avatar === 'undefined' || this.editItem.avatar === undefined || this.editItem.avatar === ''){
                    // console.log('this.avatar=' + this.avatar)
                    return require('@/assets/product/default.jpg')
                }
                //return require('@/' + this.avatar)
                return this.COMMON.httpUrl + '/static' + this.editItem.avatar + '?token=Bearer '+ this.token
            }
        }
    }
</script>

<style scoped>
    .avatar {
        width: 80px;
    }
</style>
